<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
        d="M16,6.4V0L7.88,8,16,16V9.6a9.6,9.6,0,1,1-9.75,9.6H3A12.9,12.9,0,0,0,16,32,12.9,12.9,0,0,0,29,19.2,12.9,12.9,0,0,0,16,6.4Z" />
</svg>